module.exports = __webpack_public_path__ + "static/img/logo_header_on_white.08878a60.svg";